import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 实时广播列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	realtimeList( params={} ) {
		return request({
	    url: baseUrl + '/device/broadcast',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 实时广播添加
	**/
	realtimeAdd(data){
		return request({
			url: baseUrl + '/device/broadcast',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播编辑
	**/
	realtimeEdit(id,data){
		return request({
			url: baseUrl + '/device/broadcast/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 实时广播删除
	**/
	realtimeDel(id){
		return request({
			url: baseUrl + '/device/broadcast/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 实时广播设置循环次数
	**/
	realtimeSetTimes(data){
		return request({
			url: baseUrl + '/device/broadcast/setTimes',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播设置音量
	**/
	realtimeSetVolume(data){
		return request({
			url: baseUrl + '/device/broadcast/setVolume',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播开始播放
	**/
	realtimeSetOn(data){
		return request({
			url: baseUrl + '/device/breakers/on',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播停止播放
	**/
	realtimeSetClose(data){
		return request({
			url: baseUrl + '/device/breakers/close',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播音乐列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	relatedList( params={} ) {
		return request({
	    url: baseUrl + '/device/related',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 定时广播 添加
	**/
	relatedAdd(data){
		return request({
			url: baseUrl + '/device/related',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播音乐列表编辑
	**/
	relatedEdit(id,data){
		return request({
			url: baseUrl + '/device/related/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 实时广播删除
	**/
	relatedDel(id){
		return request({
			url: baseUrl + '/device/related/'+id,
			method:'DELETE'
		})
	}
}